<div class="container-info light pb-5">
    <div class="head d-flex justify-content-between">
        <p>Mi perfil transaccional</p>
    </div>

    <form class="animated fadeIn pb-5" [formGroup]="formToSend" (ngSubmit)="sendInfo()">

        <div class="d-block m-auto mt-4 w-75">
            <h4 class="cl-pink fs-25 mt-5 fw-bold mb-0 text-start">Perfil transaccional</h4>
            <p class="cl-grey fs-15 fw-sbold mt-3 mb-4">Cuéntanos un poco sobre tus planes de inversión</p>
   
            <p class="fs-14 cl-grey m-0">
               Estos datos serán un aproximado de cómo piensas operar en la plataforma
            </p>

            <hr>

            <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                  <!-- Tu mat-radio-group aquí -->
                </div>
                <!-- Repite para cada grupo de botones de radio -->
              </div>

            <div class="questions mt-3">
                <div class="mt-3 mb-5">
                    <p class="fw-sbold cl-grey fs-15 m-0 pb-2">¿Cuántas veces al mes piensas ingresar fondos? <span class="text-danger"> *</span></p>
                    <mat-radio-group formControlName="operationPerMonth" class="d-block w-md-50 d-md-flex align-items-center justify-content-lg-between">
                        <mat-radio-button *ngFor="let item of operationPerMonth" [value]="item.value">{{item.text}}</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="my-5">
                    <p class="fw-sbold cl-grey fs-15 m-0 pb-2">Monto de cada depósito<span class="text-danger"> *</span></p>
                    <mat-radio-group formControlName="amountsPerOperation" class="d-block w-md-50">
                        <mat-radio-button class="pe-4" *ngFor="let item of amountsPerOperation" [value]="item.value">{{item.text}}</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="my-5">
                    <p class="fw-sbold cl-grey fs-15 m-0 pb-2">¿Cuál es el origen de estos recursos? <span class="text-danger"> *</span></p>
                    <mat-radio-group formControlName="origenMoney" class="d-block w-md-50 d-md-flex align-items-center justify-content-lg-between">
                        <mat-radio-button *ngFor="let item of origenMoney" [value]="item.value">{{item.text}}</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="my-5">
                    <p class="fw-sbold cl-grey fs-15 m-0 pb-2">¿Qué destino le darás a tu inversión?<span class="text-danger"> *</span></p>
                    <div class="w-100">
                        <mat-radio-group formControlName="destinationInvestment" class="d-block w-md-50 d-md-flex align-items-center justify-content-lg-between">
                            <mat-radio-button *ngFor="let item of destinationInvestment" [value]="item.value">{{item.text}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <!---
                <div class="my-5">
                    <p class="fw-sbold cl-grey fs-15 m-0 pb-2">¿Qué te motiva a invertir en nuestra plataforma?<span class="text-danger"> *</span></p>
                    <textarea class="form-control text-area" rows="3" formControlName="answerUser"></textarea>
                </div>
                -->
            </div>

        </div>

        <div class="d-flex flex-column justify-content-center align-items-center mt-5 mb-1 animated fadeIn">
            <button mat-button [disabled]="!formToSend.valid">Continuar</button>
         </div>
    </form>

</div>